import React, { Component, Fragment } from 'react';

// prettier-ignore
const AMAZON_TAM_SCRIPT = '!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function(){q("f",arguments)},setDisplayBids:function(){},targetingKeys:function(){return[]},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(A,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");';
const AMAZON_TAM_SCRIPT_TIMEOUT = 2000;
const AMAZON_TAM_BID_TIMEOUT = 2000;

class AmazonTam extends Component {
  static init() {
    // If the APS script takes too long to load, resolve so that we can render
    // ads without APS
    const _timeout = new Promise(resolve => {
      window.setTimeout(() => {
        resolve();
      }, AMAZON_TAM_SCRIPT_TIMEOUT);
    });

    const _init = new Promise(resolve => {
      window.apstag.init(
        {
          pubID: '3389',
          adServer: 'googletag',
          simplerGPT: true,
          videoAdServer: 'DFP'
        },
        () => {
          window._aps = true;
          resolve();
        }
      );
    });

    return Promise.race([_init, _timeout]);
  }

  static fetchVideoBid(placement) {
    // Check if APS has loaded
    if (window._aps) {
      // Fetch bid
      return new Promise(resolve => {
        window.apstag.fetchBids(
          {
            slots: [
              {
                slotID: placement,
                mediaType: 'video'
              }
            ]
          },
          bids => {
            if (bids.length > 0) {
              // If we have received any bids back
              resolve(bids[0].encodedQsParams);
            }
            resolve('');
          }
        );
      });
    }
    return Promise.resolve();
  }

  static fetchBannerBids(slots) {
    // Check if APS has loaded
    if (window._aps) {
      // Fetch bid
      return new Promise(resolve => {
        window.googletag.cmd.push(() => {
          window.apstag.fetchBids(
            { slots, timeout: AMAZON_TAM_BID_TIMEOUT },
            (/* bids */) => {
              window.apstag.setDisplayBids();
              resolve(slots);
            }
          );
        });
      });
    }
    return Promise.resolve();
  }

  static Head() {
    return (
      <Fragment>
        <script
          key="tam-1"
          dangerouslySetInnerHTML={{ __html: AMAZON_TAM_SCRIPT }}
        />
      </Fragment>
    );
  }
  render() {
    return null;
  }
}

export default AmazonTam;
